import { render, staticRenderFns } from "./AddRelationshipPopup.vue?vue&type=template&id=10aac766&"
import script from "./AddRelationshipPopup.vue?vue&type=script&lang=js&"
export * from "./AddRelationshipPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports